
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/components/HomePage.vue';
import BlogListing from '@/components/BlogListing.vue';
import BlogPost from '@/components/BlogPost.vue';
import Portfolio from '@/components/Portfolio.vue';
import PortfolioNew from '@/components/PortfolioNew.vue';

import BlogPostWrapper from '@/components/BlogPostWrapper.vue';
const routes = [
    { path: '/', component: BlogListing},
    { path: '/blog', component: BlogListing},
    { path: '/blog/page/:page', component: BlogListing ,props: true},
    {
        path: '/blog/:id',
        name: 'BlogPost',
        component: BlogPostWrapper,
	props: true
    },
    { path: '/portfolio', component: PortfolioNew},
    { path: '/portfolio/:place', component: PortfolioNew,props: true},
  // You can add routes for Blog and Resources when you create those components
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
